import { budgetPeriodEnum } from "./budget.enum";

export class BudgetDto {
    id: number
    budgetPeriod: budgetPeriodEnum;
    fromDate: Date | string;
    toDate: Date | string;
    budget: number;
    isActive: boolean;
    createdUser: string | null;
    updatedUser: string | null;
    versionFlag: number;
    departmentName: number;
    constructor(
        id: number,
        budgetPeriod: budgetPeriodEnum,
        fromDate: Date | string,
        toDate: Date | string,
        budget: number,
        departmentName: number,
        isActive: boolean,
        createdUser: string | null,
        updatedUser: string | null,
        versionFlag: number,
    ) {
        this.id = id;
        this.budgetPeriod = budgetPeriod
        this.fromDate = fromDate;
        this.toDate = toDate;
        this.budget = budget;
        this.departmentName = departmentName;
        this.isActive = isActive;
        this.createdUser = createdUser;
        this.updatedUser = updatedUser;
        this.versionFlag = versionFlag;
    }




}